<template>
  <div>
    <div v-if="dialogVisible && payReady" class="subscription-pay-overlay">
      <div class="subscription-pay-dialog">
      <button class="subscription-pay-close" type="button" @click="handleCancel">
        ✕
      </button>

      <h2 class="subscription-pay-title" style="margin-top: 0.71429rem;">{{ planTitle }}<span v-if="isEnterprise">·{{plan.seat}}席位</span> ¥{{ displayNewPlanPrice }}</h2>
			<p class="subscription-pay-subtitle">当前{{ preview.currentPlanName }}{{ preview.currentSeats && isEnterprise ? `·${preview.currentSeats}席位` : '' }}{{getCurrentPeriodType()}}</p>
			<p v-if="previewSubtitle" class="subscription-pay-subtitle">
        {{ previewSubtitle }}
      </p>
      <p v-else-if="previewLoading" class="subscription-pay-subtitle">
        升级信息加载中...
      </p>

      <div class="subscription-pay-price-row">
        <span class="subscription-pay-price">¥{{ displayRemainingPlanPrice }}</span>
        <!-- <span v-if="displayPaidAmount" class="subscription-pay-original">
          ¥{{ displayPaidAmount }} (已付)
        </span> -->
      </div>

      <div class="subscription-pay-qr">
        <img
          v-if="qrCodeImgUrl"
          class="subscription-pay-qr-image"
          :src="qrCodeImgUrl"
          alt=""
        />
        <div
          v-else-if="previewLoading || orderLoading"
          class="subscription-pay-qr-placeholder"
        >
          二维码加载中...
        </div>
        <div v-else class="subscription-pay-qr-placeholder">
          {{ qrPlaceholderText }}
        </div>
      </div>

      <div class="subscription-pay-methods">
        <label class="subscription-pay-method">
          <input
            v-model="paymentMethod"
            type="radio"
            value="2"
            :disabled="previewLoading || orderLoading"
            @change="handlePaymentMethodChange"
          />
          <span>支付宝</span>
        </label>
        <label class="subscription-pay-method">
          <input
            v-model="paymentMethod"
            type="radio"
            value="1"
            :disabled="previewLoading || orderLoading"
            @change="handlePaymentMethodChange"
          />
          <span>微信</span>
        </label>
      </div>

      <p class="subscription-pay-tip">扫码支付后自动开通</p>

      <div class="subscription-pay-actions">
        <button
          type="button"
          class="subscription-pay-cancel"
          :disabled="previewLoading || orderLoading"
          @click="handleCancel"
        >
          取消
        </button>
        <button
          type="button"
          class="subscription-pay-confirm"
          :disabled="previewLoading || orderLoading || !outTradeNo"
          @click="handlePaid"
        >
          已支付
        </button>
      </div>
      </div>
    </div>

    <subscription-pay-result-dialog
      :visible.sync="payResultVisible"
      @confirm="finalizePaySuccess"
    />
  </div>
</template>

<script>
import QRCode from "qrcode";
import bus from "@/bus.js";
import SubscriptionPayResultDialog from "@/views/subscription/SubscriptionPayResultDialog.vue";
import {
  cycleToPeriodType,
  formatPriceFromFen,
  getCycleLabel,
  getPaymentTypeName,
  isApiSuccess,
  normalizeSubscriptionSeat,
  persistUserFields,
} from "@/utils/subscription";

export default {
  name: "SubscriptionUpgradePayDialog",
  components: {
    SubscriptionPayResultDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    plan: {
      type: Object,
      default: null,
    },
    cycle: {
      type: String,
      default: "month",
    },
  },
  data() {
    return {
      paymentMethod: "2",
      qrCodeImgUrl: "",
      outTradeNo: "",
      previewLoading: false,
      orderLoading: false,
      payReady: false,
      pollTimerId: null,
      preview: null,
      payResultVisible: false,
      pendingSuccessType: "",
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    isEnterprise() {
      const accountType = this.$store.state.subscriptionAccountType;
      return accountType === "enterprise" || accountType === "team";
    },
    planTitle() {
      const targetPlanName = this.preview && this.preview.targetPlanName;
      if (targetPlanName) {
        return `升级到${targetPlanName} · ${getCycleLabel(this.cycle)}`;
      }
      if (!this.plan) {
        return "";
      }
      return `升级到${this.plan.name} · ${getCycleLabel(this.cycle)}`;
    },
    previewSubtitle() {
      if (!this.preview) {
        return "";
      }
      const payAmount = formatPriceFromFen(this.preview.payAmount, {
        decimal: true,
      });
      const remainingValue = formatPriceFromFen(this.preview.remainingValue);
      const remainingMonths = Number(this.preview.remainingMonths || 0);
      return `原价 ¥${formatPriceFromFen(this.preview.currentOriginalPrice)} · 剩余价值¥${remainingValue}`;
    },
		 displayNewPlanPrice() {
			if (!this.preview) {
				return "";
			}
			const price = formatPriceFromFen(this.preview.newPlanPrice); 
			return price.replace(/^-?\d+/, (integerPart) => integerPart.replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","), );
		},
    displayRemainingPlanPrice() {
			console.log(this.preview, 'this.previewthis.preview');
      if (!this.preview) {
        return "—";
      }
      const payAmount = formatPriceFromFen(this.preview.payAmount, {
        decimal: true,
      });
			return payAmount;
    },
    displayPaidAmount() {
      if (!this.preview) {
        return "";
      }
      const remainingValue = Number(this.preview.remainingValue || 0);
			console.log(remainingValue, 'remainingValueremainingValue');
      if (!remainingValue) {
        return "";
      }
      return formatPriceFromFen(remainingValue);
    },
    qrPlaceholderText() {
      return Number(this.paymentMethod) === 1 ? "微信扫码支付" : "支付宝扫码支付";
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.resetPayState();
        this.loadPreview();
      } else {
        this.stopPolling();
      }
    },
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
		getCurrentPeriodType() {
			if (!this.preview) {
				return "";
			}
			// currentPeriodType: 1月卡 2季卡 3年卡 4半年卡
			return this.preview.currentPeriodType === 1
				? "月卡"
				: this.preview.currentPeriodType === 2
					? "季卡"
					: this.preview.currentPeriodType === 3
						? "年卡"
						: this.preview.currentPeriodType === 4
							? "半年卡"
							: "";
		},
    resetPayState() {
      this.paymentMethod = "2";
      this.qrCodeImgUrl = "";
      this.outTradeNo = "";
      this.previewLoading = false;
      this.orderLoading = false;
      this.payReady = false;
      this.preview = null;
    },
    handlePaymentMethodChange() {
      if (this.preview) {
        this.createOrder();
      }
    },
    closeWithoutPayReady() {
      this.dialogVisible = false;
      this.$emit("close");
    },
    handleCancel() {
      this.closeWithoutPayReady();
    },
    handlePaid() {
      this.checkPayState().then((success) => {
        if (success) {
          return;
        }
        if (this.$message) {
          this.$message.warning("暂未检测到支付成功，请完成扫码后再试");
        }
      });
    },
    loadPreview() {
      if (!this.plan || !this.plan.configId) {
        return;
      }

      this.previewLoading = true;
      this.$axios
        .post(
          `${this.$store.state.serverUrl}ytb/subscription/upgrade/preview`,
          {
            configId: Number(this.plan.configId),
            periodType: cycleToPeriodType(this.cycle),
            seats: normalizeSubscriptionSeat(this.plan.seat),
          },
        )
        .then((res) => {
          if (!isApiSuccess(res.data.code)) {
            if (this.$message) {
              this.$message.error(res.data.message || "获取升级预览失败");
            }
            this.closeWithoutPayReady();
            return;
          }

          this.preview = res.data.data || {};
          this.createOrder();
        })
        .catch(() => {
          if (this.$message) {
            this.$message.error("获取升级预览失败");
          }
          this.closeWithoutPayReady();
        })
        .finally(() => {
          this.previewLoading = false;
        });
    },
    createOrder() {
      if (!this.plan || !this.plan.configId || !this.preview) {
        return;
      }

      this.stopPolling();
      this.qrCodeImgUrl = "";
      this.outTradeNo = "";
      this.orderLoading = true;

      const paymentType = getPaymentTypeName(this.paymentMethod);
      this.$axios
        .post(
          `${this.$store.state.serverUrl}ytb/subscription/upgrade/pay/create/${paymentType}`,
          {
            configId: Number(this.plan.configId),
            seats: normalizeSubscriptionSeat(this.plan.seat),
          },
        )
        .then(async (res) => {
          if (!isApiSuccess(res.data.code)) {
            if (this.$message) {
              this.$message.error(res.data.message || "创建升级订单失败");
            }
            this.closeWithoutPayReady();
            return;
          }

          const data = res.data.data || {};
          const qrSource = data.codeUrl || data.key;
          const tradeNo = data.outTradeNo || data.key;
          if (!qrSource || !tradeNo) {
            if (this.$message) {
              this.$message.error("未获取到支付信息");
            }
            this.closeWithoutPayReady();
            return;
          }

          this.outTradeNo = tradeNo;
          try {
            this.qrCodeImgUrl = await QRCode.toDataURL(String(qrSource), {
              width: 220,
              margin: 1,
            });
          } catch (error) {
            if (this.$message) {
              this.$message.error("二维码生成失败");
            }
            this.closeWithoutPayReady();
            return;
          }

          this.payReady = true;
          this.pollTimerId = setInterval(() => {
            this.checkPayState("automaticPolling");
          }, 1500);
        })
        .catch(() => {
          if (this.$message) {
            this.$message.error("创建升级订单失败");
          }
          this.closeWithoutPayReady();
        })
        .finally(() => {
          this.orderLoading = false;
        });
    },
    checkPayState(type) {
      if (!this.outTradeNo) {
        return Promise.resolve(false);
      }

      const paymentType = getPaymentTypeName(this.paymentMethod);
      return this.$axios
        .get(`${this.$store.state.serverUrl}ytb/subscription/pay/state`, {
          params: {
            outTradeNo: this.outTradeNo,
            paymentType,
          },
          multipleCancel: true,
        })
        .then((res) => {
          if (isApiSuccess(res.data.code) && res.data.data === "SUCCESS") {
            this.handlePaySuccess(type);
            return true;
          }
          return false;
        })
        .catch(() => false);
    },
    handlePaySuccess(type) {
      this.stopPolling();
      this.dialogVisible = false;
      this.pendingSuccessType = type || "";
      this.payResultVisible = true;
    },
    finalizePaySuccess() {
      this.payResultVisible = false;
      this.refreshUserInfo();
      this.$store.dispatch("fetchUserSubscription");
      bus.$emit("allPoints");
      this.$emit("success", {
        plan: this.plan,
        cycle: this.cycle,
        auto: this.pendingSuccessType === "automaticPolling",
        preview: this.preview,
      });
      this.pendingSuccessType = "";
    },
    refreshUserInfo() {
      this.$axios
        .get(`${this.$store.state.serverUrl}ytb/user/select/userById`)
        .then((res) => {
          if (!isApiSuccess(res.data.code)) {
            return;
          }
          const data = res.data.data || {};
          persistUserFields({ vipType: data.vipType });
          this.$store.commit("setUserSubscriptionInfo", {
            vipType: Number(data.vipType || 0),
          });
        });
    },
    stopPolling() {
      if (this.pollTimerId) {
        clearInterval(this.pollTimerId);
        this.pollTimerId = null;
      }
    },
  },
};
</script>

<style lang="less" scoped>
/* 尺寸按设计稿 px/14 转 rem；字号用 max(12PX, Nrem) 保证小屏不低于 12px */

.subscription-pay-overlay {
  position: fixed;
  inset: 0;
  z-index: 3100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.72);
}

.subscription-pay-dialog {
  position: relative;
  width: 30rem;
  padding: 2rem 2.28571rem 1.71429rem;
  border-radius: 1.14286rem;
  background: #12121e;
  box-shadow: 0 1.71429rem 4.57143rem rgba(0, 0, 0, 0.45);
  text-align: center;
}

.subscription-pay-close {
  position: absolute;
  top: 1.14286rem;
  left: 1.14286rem;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #8b93a7;
  cursor: pointer;
  font-size: ~"max(12PX, 1rem)";
  line-height: 1;
}

.subscription-pay-title {
  margin: 0;
  color: #ffffff;
  font-size: ~"max(12PX, 1.14286rem)";
  line-height: 2.28571rem;
  font-weight: 700;
}

.subscription-pay-subtitle {
  margin: 0.42857rem 0 0;
  color: #8b93a7;
  font-size: ~"max(12PX, 1rem)";
}

.subscription-pay-price-row {
  margin-top: 1.28571rem;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.71429rem;
}

.subscription-pay-price {
  color: #f0b90b;
  font-size: ~"max(12PX, 2.42857rem)";
  font-weight: 800;
  line-height: 1;
}

.subscription-pay-original {
  color: #5d6476;
  font-size: ~"max(12PX, 1.14286rem)";
  text-decoration: line-through;
}

.subscription-pay-qr {
  width: 15.71429rem;
  height: 15.71429rem;
  margin: 1.57143rem auto 0;
  border-radius: 0.85714rem;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.subscription-pay-qr-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.subscription-pay-qr-placeholder {
  color: #6b7280;
  font-size: ~"max(12PX, 1rem)";
}

.subscription-pay-methods {
  margin-top: 1.28571rem;
  display: flex;
  justify-content: center;
  gap: 2rem;
}

.subscription-pay-method {
  display: inline-flex;
  align-items: center;
  gap: 0.57143rem;
  color: #d8deea;
  font-size: ~"max(12PX, 1rem)";
  cursor: pointer;

  input {
    width: 1.14286rem;
    height: 1.14286rem;
    margin: 0;
    accent-color: #8b5cf6;
    cursor: pointer;
  }
}

.subscription-pay-tip {
  margin: 0.71429rem 0 0;
  color: #6f778b;
  font-size: ~"max(12PX, 0.85714rem)";
}

.subscription-pay-actions {
  margin-top: 1.57143rem;
  display: flex;
  gap: 0.85714rem;
}

.subscription-pay-cancel,
.subscription-pay-confirm {
  flex: 1;
  height: 3rem;
  border-radius: 0.57143rem;
  font-size: ~"max(12PX, 1.07143rem)";
  font-weight: 700;
  cursor: pointer;
}

.subscription-pay-cancel {
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: transparent;
  color: #d8deea;
}

.subscription-pay-confirm {
  border: none;
  background: #8b5cf6;
  color: #ffffff;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
}
</style>
